var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mono",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#888888"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 98,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.05 0 0 1.05 -5 -5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 79,
    width: 21,
    height: 70,
    fill: "url(#mono)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 61.5,
    r: 12.25,
    fill: "url(#mono)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5 79 h20.3 v9.1 a21.77 21.77 0 0 1 18.9 -9.8 c10.85 0 23.52 6.02 23.52 25.62 V149 h-21 v-33.18 c0 -9.94 -4.2 -13.51 -9.66 -13.51 A12.18 12.18 0 0 0 110.5 115.33 V149 h-21 z",
    fill: "url(#mono)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.219e5cb4be64a9776450225cdff21f16.svg";
export { ForwardRef as ReactComponent };